export enum ApiDictionaryUrlEnum {
  couponStatus = '/api/Dictionary/CouponStatus',
  helpRequestStatus = '/api/Dictionary/helpRequestStatus',
  messengerType = '/api/Dictionary/MessengerType',
  eventsKind = '/api/Dictionary/EventsKind',
  entityList = '/api/Events/Entity',
  incidentStatus = '/api/Dictionary/IncidentStatus'
}
